<template>
  <div class="auth-page">
    <div class="container page d-flex h-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <card class="auth-page__form" title="Sign In">
            <form v-on:submit.prevent="onSubmit(email, password)">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control form-control-lg mb-3"
                    type="text"
                    v-model="email"
                    placeholder="Email"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control form-control-lg mb-3"
                    type="password"
                    v-model="password"
                    placeholder="Password"
                  />
                </div>
                <button class="btn btn-primary pull-xs-right">
                  Sign in
                </button>
              </fieldset>

              <p class="text-xs-center mt-4">
                <router-link :to="{ name: 'reset password' }">
                  Forgot password?
                </router-link>
              </p>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LOGIN } from '@/store/actions.type'

export default {
  data() {
    return {
      email: null,
      password: null
    };
  },

  methods: {
    onSubmit(email, password) {
      this.$store
        .dispatch(LOGIN, { email, password })
        .then(() => {
          this.$router.push({ name: "dashboard" })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.auth-page {
  background-color: #eaeaea;
  background-image: url('~@/assets/img/login-bg.jpg');
  background-size: cover;
  height: 100vh;

  &__form {
    box-shadow:
      0 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0 6.7px 5.3px rgba(0, 0, 0, 0.028),
      0 12.5px 10px rgba(0, 0, 0, 0.035),
      0 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0 41.8px 33.4px rgba(0, 0, 0, 0.05),
      0 100px 80px rgba(0, 0, 0, 0.07);
  }
}
</style>
